import { render, staticRenderFns } from "./RtcGroupJoin.vue?vue&type=template&id=33cb19ea&scoped=true"
import script from "./RtcGroupJoin.vue?vue&type=script&lang=js"
export * from "./RtcGroupJoin.vue?vue&type=script&lang=js"
import style0 from "./RtcGroupJoin.vue?vue&type=style&index=0&id=33cb19ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cb19ea",
  null
  
)

export default component.exports